import React from "react";
import { Box, Button, TextField, CircularProgress } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";

const useStyles = makeStyles((theme) => ({
  validateButton: {
    marginTop: theme.spacing(1.5),
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.white,
    "&:hover": {
      backgroundColor: theme.palette.primary.dark,
    },
  },
  urlBackground: {
    backgroundColor: "#ffffff",
  }
}));

export default function UrlInputComponent({
  urlInput,
  urlError,
  isValidating,
  isValidateDisabled,
  handleInputChange,
  handleValidateClick,
  handlePaste,
}) {
  const classes = useStyles();

  return (
    <Box>
      <TextField
        className={classes.urlInput}
        multiline
        rows={8}
        fullWidth
        placeholder="Paste single or multiple URLs here. Separate multiple URLs with new lines"
        value={urlInput}
        onChange={handleInputChange}
        onPaste={handlePaste}
        disabled={isValidating}
        error={!!urlError}
        helperText={urlError}
        inputProps={{ sx: { fontSize: "14px" } }}
      />
      <Button
        variant="contained"
        onClick={handleValidateClick}
        className={classes.validateButton}
        disabled={isValidateDisabled}
      >
        {isValidating ? (
          <>
            Validating...
            &nbsp;
            <CircularProgress size={16} color="inherit" />
          </>
        ) : (
          "Validate"
        )}
      </Button>
    </Box>
  );
}
